import { render, staticRenderFns } from "./Flow.vue?vue&type=template&id=c3a0a04c&scoped=true"
import script from "./Flow.vue?vue&type=script&lang=js"
export * from "./Flow.vue?vue&type=script&lang=js"
import style0 from "./Flow.vue?vue&type=style&index=0&id=c3a0a04c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3a0a04c",
  null
  
)

export default component.exports